// Major.Minor.Patch!
// Even Patch numbers and 0 as patch number will force the frontend to reload itself
// Uneven Patch numbers will just display a message that a new version is available to the user
export const ANKAADIA_VERSION = "2.5.9"; // <-- this is the version number
